export const PROJECTS = [
  {
    id: 'lab-automation',
    title: 'Lab Automation GUI',
    meta: 'Capstone · 2024–2025',
    icon: 'cpu',
    skills: ['Python', 'GUI Design', 'Automation'],
    bullets: [
      'Desktop interface that drives a robotic chemical synthesis workflow without touching a terminal.',
      'Translated researcher requirements into architecture, milestones, and a tested, shippable tool.',
    ],
    links: [],
  },
  {
    id: 'guro-guro',
    title: 'Guro-guro — Japanese Chess',
    meta: 'Team project · 2024',
    icon: 'grid',
    skills: ['Java', 'OOP', 'AI Logic', 'Agile'],
    bullets: [
      'Led a 4-person team with sprint planning, daily standups, and iterative delivery.',
      'Architected object-oriented game state management, move validation, and an AI opponent.',
      'Ran peer code reviews to keep quality and cohesion high.',
    ],
    links: [{ label: 'GitHub', url: 'https://github.com/YNAL7711', style: 'ghost' }],
  },
  {
    id: 'go-cache',
    title: 'Go User Cache Service',
    meta: 'Backend · 2024',
    icon: 'server',
    skills: ['Go', 'gRPC', 'Cloud Spanner', 'LRU'],
    bullets: [
      'High-performance, concurrency-safe caching service with LRU eviction for efficient memory use.',
      'gRPC client–server communication backed by Google Cloud Spanner for durable storage.',
    ],
    links: [],
  },
  {
    id: 'pfas-db',
    title: 'PFAS Database Interface',
    meta: 'Research tool · 2023',
    icon: 'database',
    skills: ['Python', 'Apps Script', 'Data Viz'],
    bullets: [
      'Search and visualization interface for a governance database used by 500+ people.',
      '25% faster searches and 30% higher engagement after iterative refinement.',
    ],
    links: [],
  },
  {
    id: 'todo',
    title: 'React To-Do List',
    meta: 'Personal · 2024',
    icon: 'check',
    skills: ['React', 'Hooks', 'CSS'],
    bullets: [
      'Fully responsive task manager with component-based architecture and React Hooks.',
      'Task creation, deletion, completion tracking, and persistent local storage.',
    ],
    links: [{ label: 'GitHub', url: 'https://github.com/YNAL7711', style: 'ghost' }],
  },
  {
    id: 'ds-viz',
    title: 'Data Structure Visualizer',
    meta: 'Educational tool · 2025',
    icon: 'activity',
    skills: ['React', 'Algorithms', 'Animation'],
    bullets: [
      'Interactive tool that animates data structures and algorithms step by step.',
      'Built to make core CS concepts intuitive for students.',
    ],
    links: [],
  },
];
